import { Dialog, DialogFooter } from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { FormSpinner } from "../../../../components/FormSpinner";
import { StyledPrimaryButton } from "../../../../components/styled";
import { useSelector } from "../../../../store/hooks";
import {
  deleteResponseRoutine,
  setDeleteResponseDialog,
} from "../../../../store/recommendationPage";

export const DeleteResponseDialog = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { response } = useSelector(
    (s) => s.recommendationPage.deleteResponseDialog
  );
  const isLoading = useSelector(
    (s) => s.recommendationPage.deleteResponseLoadStatus === "loading"
  );

  const close = () => {
    dispatch(
      setDeleteResponseDialog({
        response: null,
        isOpen: false,
      })
    );
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        showCloseButton: true,
        title: t("greco.areYouSure"),
      }}
      onDismiss={close}
    >
      {t("greco.deletingIsPermanent")}
      <DialogFooter>
        <StyledPrimaryButton
          text={t("greco.delete")}
          onClick={() => {
            dispatch(
              deleteResponseRoutine.trigger({
                locationId: response.locationId,
                reportId: response.reportId,
                recommendationId: response.recommendationId,
                responseId: response.responseId,
              })
            );
          }}
          disabled={isLoading}
        />
      </DialogFooter>
      {isLoading && <FormSpinner />}
    </Dialog>
  );
};
